import { MenuDivider as MenuDividerComponent, MenuDividerProps } from '@chakra-ui/menu';
import * as React from 'react';

export type IMenuDividerProps = MenuDividerProps;

export const MenuDivider: React.FunctionComponent<IMenuDividerProps> = (props) => {
  return <MenuDividerComponent {...props} />;
};
